import { ReactNode } from "react";
import { Modal as AntModal } from "antd";
import { Button } from "@/components/ui";

interface SendConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  campaignName: string;
  /**
   * How many recipients this send is addressed to. Omit when the number is not
   * known on this page — the line is then left out rather than shown as zero.
   */
  recipientCount?: number;
  /**
   * Anything else the sender should know before confirming, such as who gets
   * skipped. Rendered under the recipient count.
   */
  description?: ReactNode;
  loading?: boolean;
}

const SendConfirmModal = ({
  open,
  onClose,
  onConfirm,
  campaignName,
  recipientCount,
  description,
  loading = false,
}: SendConfirmModalProps) => {
  return (
    <AntModal
      title="Send Email"
      open={open}
      onCancel={onClose}
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} loading={loading}>
            Send Now
          </Button>
        </div>
      }
      width={480}
      centered
    >
      <div className="py-2">
        <p className="text-sm text-black/65 mb-3">
          Are you sure you want to send this email campaign?
        </p>
        <div className="bg-gray-50 p-4 rounded-lg">
          <p className="text-sm font-medium text-black/85 mb-1">{campaignName}</p>
          {recipientCount !== undefined && (
            <p className="text-sm text-black/65">
              This email will be sent to <span className="font-semibold">{recipientCount}</span> recipient{recipientCount !== 1 ? "s" : ""}.
            </p>
          )}
          {description && <div className="text-sm text-black/65">{description}</div>}
        </div>
        <p className="text-xs text-black/45 mt-3">
          This action cannot be undone.
        </p>
      </div>
    </AntModal>
  );
};

export default SendConfirmModal;
